export default __webpack_public_path__ + "static/12_19-1b54966574ebd3e79f88c9228345fb42.png";